import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthService } from '@services';
import { Observable } from 'rxjs';
import { cloneAndAddHeaders, csdtAuthApp } from './lib.interceptors';

export const KeplerMindpalaceInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    const url = environment.customerAssistant.chat.feedback.url;
    const authService = inject(AuthService);

    if (req.url.startsWith(url)) {
        const clone = cloneAndAddHeaders(req, {
            Authorization: `Bearer ${authService.accessToken}`,
            'csdt-authorization-app': csdtAuthApp,
            'Content-Type': 'application/json',
            'X-API-Key': environment.customerAssistant.chat.feedback.apiKey,
        });
        console.debug('[Interceptors][KeplerMindpalaceInterceptor] Modified request:', clone);
        return next(clone);
    } else {
        return next(req);
    }
};
